/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_upload_image_api_uploads_upload_post } from '../models/Body_upload_image_api_uploads_upload_post';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UploadsService {
    /**
     * Upload Image
     * Upload a treatment image (before/after photo).
     * @returns any Successful Response
     * @throws ApiError
     */
    public static uploadImageApiUploadsUploadPost({
        formData,
    }: {
        formData: Body_upload_image_api_uploads_upload_post,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/uploads/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Image
     * Retrieve an uploaded image.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getImageApiUploadsFilenameGet({
        filename,
    }: {
        filename: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/uploads/{filename}',
            path: {
                'filename': filename,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Image
     * Delete an uploaded image.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteImageApiUploadsFilenameDelete({
        filename,
    }: {
        filename: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/uploads/{filename}',
            path: {
                'filename': filename,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
